// extracted by mini-css-extract-plugin
module.exports = {"header":"FidPointsAdmin_header__222X2","section":"FidPointsAdmin_section__2ejKo","textHeader":"FidPointsAdmin_textHeader__nOxgf"};